// Meta CAPI SHA256 Hash Helper
export async function hashUserData(userData) {
  const encoder = new TextEncoder();

  async function hash(value) {
    if (!value) return null;
    const data = encoder.encode(
      value.trim().toLowerCase().replace(/\s+/g, "")
    );
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hashBuffer))
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  }

  const entries = Object.entries(userData);
  const hashed = {};

  for (const [key, value] of entries) {
    hashed[key] = await hash(value);
  }

  return hashed;
}

// Liest _fbp aus Cookie
export function getFbpFromCookie() {
  const match = document.cookie.match(/_fbp=(fb\.[\d.]+)/);
  return match ? match[1] : null;
}

// Liest _fbc aus Cookie
export function getFbcFromCookie() {
  const match = document.cookie.match(/_fbc=([^;]+)/);
  return match ? match[1] : null;
}
